import { MarkdownBlock, StreamingCursor } from "./markdown";
import { parseMarkdown } from "./markdown/utils";

type MarkdownContentProps = {
  content: string;
  isStreaming?: boolean;
};

export default function MarkdownContent({
  content,
  isStreaming = false,
}: MarkdownContentProps) {
  const segments = parseMarkdown(content);

  return (
    <div className="text-left space-y-2">
      {segments.map((segment, index) => (
        <MarkdownBlock
          key={index}
          segment={segment}
          showCursor={isStreaming && index === segments.length - 1}
        />
      ))}
      {isStreaming && segments.length === 0 && <StreamingCursor />}
    </div>
  );
}
